export const TableActivites = [
    { 
        label: "Activité", 
        key: "tachesspecifiques",
        render: (row: any) => `${row.titre}` 
    },
]

export const TableBudgets = [
    { 
        label: "Montant", 
        key: "montant" ,
        render: (row: any) => `${row?.titre ? row?.titre : "Non renseigné"}` 
    },
    { 
        label: "Description", 
        key: "description" ,
        render: (row: any) => `${row?.description ? row?.description : "Non renseigné"}` 
    }
]

export const TableMarches = [
    {
        label: "Libelle", 
        key: "libelle" ,
        render: (row: any) => `${row.titre}` 
    },
    {
        label: "Description", 
        key: "description",
        render: (row: any) => `${row.objectif}`  
    }
]

export const TableProgrammes = [
    { 
        label: "Id", 
        key: "id",
        render: (row: any) => `${row.id}` 
    },
    { 
        label: "Programmes", 
        key: "programmes",
        render: (row: any) => `${row.libelle}` 
    },
]

export const TableStructures = [
    { 
        label: "Libelle", 
        key: "structures",
        render: (row: any) => `${row.libelle ? row.libelle : "Non renseigné"}` 
    },
    { 
        label: "Code", 
        key: "code",
        render: (row: any) => `${row.code ? row.code : "Non renseigné"}` 
    },
    { 
        label: "Structure Mère", 
        key: "mere",
        render: (row: any) => `${row.mere ? row.mere.libelle : "Non renseigné"}` 
    },
]

export const TableTypeIntervention = [
    { 
        label: "Type d'intervention", 
        key: "typeintervention",
        render: (row: any) => `${row.libelle}` 
    },
    { 
        label: "Niveau", 
        key: "niveau",
        render: (row: any) => `${row.niveau ??"Non renseigné"}`
    },
]

export const TableTypeActivites = [
    { 
        label: "Type d'activité", 
        key: "typeactivities",
        render: (row: any) => `${row.type_activite}` 
    },
]

export const TableModeExecution = [
    { 
        label: "Mode exécution", 
        key: "typeactivities",
        render: (row: any) => `${row.libelle}` 
    },
]

export const TableTache = [
    { 
        label: "N°", 
        key: "_index",
        render: (row: any) => `${row._index}` 
    },
    { 
        label: "Tâches", 
        key: "typeactivities",
        render: (row: any) => `${row.tache}` 
    },
    { 
        label: "Poids", 
        key: "poids",
        render: (row: any) => `${row.poids}%` 
    },
]

export const TableLigneBudgetaire = [
    { 
        label: "Ligne budgétaire", 
        key: "ligne",
        render: (row: any) => `${row.libelle}` 
    },
]

export const TableModePassationMarche = [
    { 
        label: "Mode de passation de marche", 
        key: "mode",
        render: (row: any) => `${row.libelle}`
    },
]

export const TableTypeModePassation = [
    { 
        label: "Type", 
        key: "type",
        render: (row: any) => `${row.libelle}`
    },
]

export const TableModePassation = [
    { 
        label: "Mode passation", 
        key: "mode_passation",
    },
]

export const TableSourceFinancement = [
    { 
        label: "Source de financement", 
        key: "source_financement",
    },
]

export const TableExpressionBesoin = [
    { 
        label: "Expression de besoin", 
        key: "expression_besoin",
        render: (row: any) => `${row.titre}` 
    },
]

export const TableRegroupementExpressionBesoin = [
    { 
        label: "Regroupements", 
        key: "regroupement_expression_besoin",
        render: (row: any) => `${row.titre}` 
    },
]

export const TableRegroupementActivite = [
    { 
        label: "Regroupements des activités", 
        key: "regroupement_activites",
        render: (row: any) => `${row.titre}` 
    },
]

export const TableCompte = [
    { 
        label: "Code", 
        key: "code",
        render: (row: any) => `${row.code}` 
    },
    { 
        label: "Intitulé du compte", 
        key: "intitule",
        render: (row: any) => `${row.intitule}` 
    },
]

export const TableTypeCompte = [
    { 
        label: "Type de compte", 
        key: "type_compte",
        render: (row: any) => `${row.libelle}` 
    },
]

export const TablePoste = [
    { 
        label: "Poste", 
        key: "poste",
        render: (row: any) => `${row.libelle}` 
    },
]

export const TableAgent = [
    { 
        label: "Nom", 
        key: "nom",
        render: (row: any) => `${row.nom}` 
    },
    { 
        label: "Prénoms", 
        key: "prenoms",
        render: (row: any) => `${row.prenoms}` 
    },
    { 
        label: "Email", 
        key: "email",
        render: (row: any) => `${row.email}` 
    },
]

export const TableUtilisateurs = [
    { 
        label: "Identifiant", 
        key: "identifiant",
        render: (row: any) => `${row.identifiant}` 
    },
    { 
        label: "Profil", 
        key: "profil",
        render: (row: any) => `${row.profil}` 
    },
]